import Logo from './Logo';

export default Logo;



// WEBPACK FOOTER //
// ./src/client/Components/Logo/index.js